import { ORG_ROLE } from "@/constants/gaoding";
import useAppStore from "@/context/store";
import { isGdMerged } from "../gaoding";

/**
 * 获取常用稿定判断的信息
 * @returns
 */
export function useGdInfo() {
  const { user, orgInfo } = useAppStore((s) => ({
    user: s.user,
    orgInfo: s.orgInfo,
  }));

  const isAdmin =
    orgInfo?.org_role?.roleEnum === ORG_ROLE.ADMIN ||
    orgInfo?.org_role?.roleEnum === ORG_ROLE.SUPER_ADMIN;

  const isVistor = orgInfo?.org_role?.roleEnum === ORG_ROLE.VISITOR;

  return {
    /**账号是否绑定过 */
    isGdMerged: isGdMerged(user),
    /**组织信息 */
    orgInfo,
    /**是否是访客 */
    isVistor,
    /**是否是管理员 */
    isAdmin,
  };
}
